import React, { useState, useContext } from 'react';
import { Nav, Navbar, NavDropdown } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import ImageDataContext from '../../providers/imageData-context';

function NavBar() {
    const { oktaAuth, authState } = useOktaAuth();
    const imageDataCtx = useContext(ImageDataContext);

    const navigate = useNavigate();
    const GROUP_NAME = 'Okta - Org2Org Federated Users';

    const allowPasswordChange = true; // This is set to true and then never updated.  Can this just be removed?

    const logout = async () => {
        await oktaAuth.revokeAccessToken(); // explicitly revoke token
        await oktaAuth.revokeRefreshToken(); // explicitly refresh token
        await oktaAuth.signOut();
        oktaAuth.tokenManager.clear();
    };
    var userEmail: string = 'Not Logged In';
    var userName: string = 'Not Logged In';
    var isInternalUser: boolean = false;
    if (!authState) {
        return <div></div>;
    }
    if (authState.isAuthenticated) {
        userEmail = authState.accessToken.claims.sub;
        userName = authState.accessToken.claims.displayName;
        if (
            authState.accessToken.claims !== undefined &&
            authState.accessToken.claims.Groups !== undefined &&
            authState.accessToken.claims.Groups.length > 0
        ) {
            var filteredStrings = authState.accessToken.claims.Groups.map((str: string) =>
                str.toLowerCase()
            );
            isInternalUser = filteredStrings.includes(GROUP_NAME.toLowerCase());
        }
    }

    const clearCache = () => {
        imageDataCtx.clearCache();
    };

    const userNameSection = (
        <div className='userNameSection'>
            <span className='primary-text'>{userName}</span>
            <span className='secondary-text'>{userEmail}</span>
        </div>
    );

    var fontStyle = { fontSize: '14px' };

    if (authState.isAuthenticated) {
        return (
            <div tabIndex={-1}>
                <Navbar tabIndex={-1} className='navbar navbar-dark py-0  navbar-expand-lg py-md-0'>
                    <Nav tabIndex={-1} className='container-fluid'>
                        <Nav.Item>&nbsp;</Nav.Item>
                        <Nav.Item>
                            <NavDropdown
                                tabIndex={-1}
                                title={userNameSection}
                                id='navbarScrollingDropdown'
                            >
                                {!isInternalUser && (
                                    <NavDropdown.Item
                                        style={{
                                            display: allowPasswordChange ? 'block' : 'none',
                                            fontSize: '14px',
                                        }}
                                        onClick={() => {
                                            navigate('/account/change-password');
                                        }}
                                    >
                                        <Icon.ShieldFillCheck /> Change Password
                                    </NavDropdown.Item>
                                )}
                                <NavDropdown.Item
                                    style={{
                                        display: 'block',
                                        fontSize: '14px',
                                    }}
                                    onClick={clearCache}
                                >
                                    <Icon.FileEarmarkXFill /> Clear System Cache
                                </NavDropdown.Item>
                                {!isInternalUser && <NavDropdown.Divider />}
                                {/* This is should be uncomment after first phase 1 release */}
                                {/* <NavDropdown.Item  style={fontStyle} onClick={() => { history.push("/reports"); }}><Icon.FileEarmarkBarGraph />{' '}Reports</NavDropdown.Item> */}

                                <NavDropdown.Item style={fontStyle} onClick={logout}>
                                    <Icon.Power /> Sign Out
                                </NavDropdown.Item>
                            </NavDropdown>
                        </Nav.Item>
                    </Nav>
                </Navbar>
            </div>
        );
    } else {
        return <></>;
    }
}

export default NavBar;
